var EVENT_DOMAINS = {
    US: {
        PRODUCTION: 'https://us.yextevents.com',
        SANDBOX: 'https://sbx.us.yextevents.com',
    },
    EU: {
        PRODUCTION: 'https://eu.yextevents.com',
        SANDBOX: undefined
    }
};
var CONVERSION_TRACKING_DOMAINS = {
    US: {
        PRODUCTION: 'https://realtimeanalytics.yext.com',
        SANDBOX: 'https://sandbox-realtimeanalytics.yext.com',
    },
    EU: {
        PRODUCTION: undefined,
        SANDBOX: undefined
    }
};
export function getChatEndpoint(region, environment) {
    var domain = getEventDomain(region, environment);
    return "".concat(domain, "/accounts/me/events");
}
export function getSearchEndpoint(businessId, region, environment, customDomain) {
    var domain = customDomain ? customDomain : getEventDomain(region, environment);
    return "".concat(domain, "/realtimeanalytics/data/answers/").concat(businessId);
}
export function getPagesEndpoint(region, isConversionTrackingEnabled) {
    var domain = isConversionTrackingEnabled
        ? getConversionTrackingDomain(region)
        : getEventDomain(region);
    return "".concat(domain, "/store_pagespixel");
}
export function getConversionTrackingEndpoint() {
    var domain = getConversionTrackingDomain('US', 'PRODUCTION');
    return "".concat(domain, "/conversiontracking/conversion");
}
export function getConversionTrackingListingsEndpoint() {
    var domain = getConversionTrackingDomain('US', 'PRODUCTION');
    return "".concat(domain, "/listings");
}
function getConversionTrackingDomain(region, env) {
    return getDomain(CONVERSION_TRACKING_DOMAINS, region, env, true);
}
function getEventDomain(region, env) {
    return getDomain(EVENT_DOMAINS, region, env);
}
function getDomain(domainMap, region, env, conversionTrackingEnabled) {
    if (region === void 0) { region = 'US'; }
    if (env === void 0) { env = 'PRODUCTION'; }
    if (conversionTrackingEnabled === void 0) { conversionTrackingEnabled = false; }
    var domain = domainMap[region][env];
    if (!domain) {
        throw Error("The combination of the environment: \"".concat(env, "\", region: \"").concat(region, "\",")
            + "and conversionTrackingEnabled: \"".concat(conversionTrackingEnabled, "\" is unsupported."));
    }
    return domain;
}
//# sourceMappingURL=endpointProviders.js.map